import { useState, useRef } from 'react';

export function useTabState() {
  const [whiteboards, setWhiteboards] = useState([]);
  const [currentTab, setCurrentTabState] = useState(0);
  const [whiteboardCursorPositions, setWhiteboardCursorPositions] = useState({});
  const [teacherCursor, setTeacherCursor] = useState(null);
  const [studentCursor, setStudentCursor] = useState(null);
  const [prevTab, setPrevTab] = useState(0);
  const [containers, setContainers] = useState([{ id: 1, type: 'editor' }]);
  const [docContainers, setDocContainers] = useState({});
  const [homeworkContainers, setHomeworkContainers] = useState({});
  const [homeworkDataCache, setHomeworkDataCache] = useState({});
  const [sendHomeworkSubmittingId, setSendHomeworkSubmittingId] = useState(null);
  const [homeworkSuccessToast, setHomeworkSuccessToast] = useState(null);
  const tabSwitchInProgressRef = useRef(false);
  const processedHomeworkRef = useRef(new Set());
  const lastHomeworkIdRef = useRef(null);

  return {
    whiteboards, setWhiteboards,
    currentTab, setCurrentTabState,
    whiteboardCursorPositions, setWhiteboardCursorPositions,
    teacherCursor, setTeacherCursor,
    studentCursor, setStudentCursor,
    prevTab, setPrevTab,
    containers, setContainers,
    docContainers, setDocContainers,
    homeworkContainers, setHomeworkContainers,
    homeworkDataCache, setHomeworkDataCache,
    sendHomeworkSubmittingId, setSendHomeworkSubmittingId,
    homeworkSuccessToast, setHomeworkSuccessToast,
    tabSwitchInProgressRef,
    processedHomeworkRef,
    lastHomeworkIdRef,
  };
}
